// extracted by mini-css-extract-plugin
export default {"title":"EnrollSourceOfFunds_title__pxkv1","subTitle":"EnrollSourceOfFunds_subTitle__9bJW-","wrapper":"EnrollSourceOfFunds_wrapper__bje7o","row":"EnrollSourceOfFunds_row__qUxL6"};